module.exports = __webpack_public_path__ + "b55226ca8b27e1151bafd880b6c8a9b0.pdf";